module.exports = __webpack_public_path__ + "img/swingVariabilityText9.d62f5260.png";